var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};


Curriculog.ProposalForm.SmartFieldModel = (function ($, _, Backbone, SmartFieldModel) {

    SmartFieldModel = Curriculog.ProposalForm.FieldModel.extend({

        initialize: function(attrs, options) {
            Curriculog.ProposalForm.FieldModel.prototype.initialize.apply(this, arguments);

            this.bindValidation(attrs);
        },

        /**
         * Overrides the existing field validation to work with our JSONified field values
         *
         * @param   {Object} attrs - This models attributes
         */
        bindValidation: function(attrs) {
            var maxLength = attrs.maxLength,
                field = attrs.displayText,
                required = attrs.required;

            /**
             * Custom smartfield validator
             *
             * @param   {String} value         - A JSONified object or ''.
             * @param   {String} attr          - The name of the attribute - always 'value'.
             * @param   {Object} computedState - The models attributes before change.
             * @returns {String|undefined}     - String message on error | undefined on success.
             */
            this.validation.value = function(value, attr, computedState) {
                value = JSON.parse(value || "[]");

                if (required && !value.length) {
                    return field +' is required.';
                }

                if (maxLength < 1 || value.length <= maxLength) {
                    return undefined;
                }

                var errorMessage = field +' can only have '+ maxLength +' item';

                if (maxLength > 1) {
                    errorMessage += 's';
                }

                return errorMessage +'.';
            };
        },

        /**
         * Parses the JSON value of the smarfield and returns a space separated string of values
         *
         * @returns {String}
         */
        getDisplayValue: function() {
            var value = this.get('value');

            if (!value) {
                return '';
            }

            value = JSON.parse(value);
            return _.pluck(value, 'name').join(' ');
        }
    });

    return SmartFieldModel;

})($, _, Backbone, Curriculog.ProposalForm.SmartFieldModel || {});
